import { BorcluCariHesaplarReportPage } from './../pages/Raporlars/borclu-cari-hesaplar-report/borclu-cari-hesaplar-report';
import { AlacakliCariHesaplarReportPage } from './../pages/Raporlars/alacakli-cari-hesaplar-report/alacakli-cari-hesaplar-report';
import { KasaHareketleriRaporPage } from './../pages/Raporlars/kasa-hareketleri-rapor/kasa-hareketleri-rapor';
import { HakkindaPage } from './../pages/hakkinda/hakkinda';
import { KasiyerBazliRaporPage } from './../pages/Raporlars/kasiyer-bazli-rapor/kasiyer-bazli-rapor';
import { PersonelListesiPage } from './../pages/CariIslemleri/personel-listesi/personel-listesi';
import { MarkaListesiPage } from './../pages/Yonetim/MarkaIslemleri/marka-listesi/marka-listesi';
import { KategoriListePage } from './../pages/Yonetim/KategoriIslemleri/kategori-liste/kategori-liste';
import { BirimListePage } from './../pages/Yonetim/BirimIslemleri/birim-liste/birim-liste';
import { SatispagePage } from './../pages/Muhasebe/Satis/satispage/satispage';
import { AciklamaListePage } from './../pages/Yonetim/aciklama-liste/aciklama-liste';
import { KayitFormPage } from './../pages/ServisKayit/kayit-form/kayit-form';
import { IsListesiPage } from './../pages/ServisKayit/is-listesi/is-listesi';
import { BankListePage } from './../pages/Yonetim/BankaIslemleri/bank-liste/bank-liste';
import { GelirgiderPage } from './../pages/Yonetim/gelirgider/gelirgider';
import { KasalistePage } from './../pages/Yonetim/KasaIslemleri/kasaliste/kasaliste';
import { IsdurumPage } from './../pages/Yonetim/isdurum/isdurum';
import { KullaniciListePage } from './../pages/Yonetim/kullanici-liste/kullanici-liste';
import { GirisPage } from './../pages/giris/giris';
import { CarilerPage } from './../pages/CariIslemleri/cariler/cariler';
import { YonetimAnaSayfaPage } from './../pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { HomePage } from './../pages/home/home';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { StoklarPage } from '../pages/StokIslemleri/stoklar/stoklar';
import { ReportsPage } from '../pages/Raporlars/reports/reports';
import { RaporAnaSayfaPage } from '../pages/Raporlars/rapor-ana-sayfa/rapor-ana-sayfa';
import { GrupListesiPage } from '../pages/Yonetim/CariGrupIslemleri/grup-listesi/grup-listesi';
import { PersonelServisRaporuPage } from '../pages/Raporlars/personel-servis-raporu/personel-servis-raporu';
import { ProgramAyarlariPage } from '../pages/program-ayarlari/program-ayarlari';




/*
  Generated class for the PagesProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class PagesProvider {
  components = {
    "AnasayfaPage": HomePage,
    "KayitFormlari": KayitFormPage,
    "Yonetim": YonetimAnaSayfaPage,


  }
  constructor() {

  }

  menuler() {
    return new Promise((res, err) => {

      var menu = { LEFT_MENU: [], MAIN_MENU: [], KULLANICI_MENU: [], YONETIM_MENU: [], RAPOR_MENU: [],PERSONEL_MENU:[] };


      menu.LEFT_MENU = this.defaultLeftMenu;
      menu.MAIN_MENU = this.defaultMainMenu;
      menu.KULLANICI_MENU = this.KullaniciMainMenu;
      menu.YONETIM_MENU = this.YonetimMainMenu;
      menu.RAPOR_MENU = this.RaporlarMainMenu;
      menu.PERSONEL_MENU=this.PersonelMainMenu;


      res(menu);
    })

  }



  defaultLeftMenu = [
    {
      PARENT_SAYFA: { PAGE_NAME: "Yönetim" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Menü", PAGE_ION_ICON: "home", PAGE_COMPONENT: HomePage },
        { PAGE_NAME: "Müşteriler", PAGE_COMPONENT: CarilerPage },
        { PAGE_NAME: "ÇIKIŞ", PAGE_COMPONENT: GirisPage },


      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Belge İşlemleri" }, ALT_SAYFALAR: [

      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Raporlama" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Raporlar", PAGE_ION_ICON: "pie", PAGE_COMPONENT: ReportsPage }

      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Diğer İşlemler" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Ayarlar", PAGE_ION_ICON: "settings", PAGE_COMPONENT: YonetimAnaSayfaPage },


      ]
    },
  ];



  defaultMainMenu = [
    { PAGE_NAME: "Servis Kayitları", PAGE_ICON: "fa fa-file-text-o fa-3x", PAGE_COMPONENT: IsListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Perakende Satış", PAGE_ION_ICON: "train", PAGE_ICON: "fa fa-cart-plus fa-3x", PAGE_COMPONENT: SatispagePage, TYPE: "NAV", },
    { PAGE_NAME: "Müşteriler", PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: CarilerPage, TYPE: "NAV", },
    { PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
   
    // { PAGE_NAME: "Kasa Hareketleri", PAGE_ICON: "fa fa-money fa-3x", PAGE_COMPONENT: KasaHareketleriRaporPage, TYPE: "NAV", },
    { PAGE_NAME: "Raporlar", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: RaporAnaSayfaPage, TYPE: "NAV", },
    { PAGE_NAME: "Yönetim", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: YonetimAnaSayfaPage, TYPE: "NAV", },
    // { PAGE_NAME: "Hakkında", PAGE_ICON: "fa fa-info fa-3x", PAGE_COMPONENT: HakkindaPage, TYPE: "NAV", },
    // { PAGE_NAME: "ÇIKIŞ", PAGE_ICON: "fa fa-sign-out fa-3x", PAGE_COMPONENT: GirisPage, TYPE: "NAV", }

  ];
  PersonelMainMenu = [
    { PAGE_NAME: "Servis Kayitları", PAGE_ICON: "fa fa-file-text-o fa-3x", PAGE_COMPONENT: IsListesiPage, TYPE: "NAV", },
     { PAGE_NAME: "Müşteriler", PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: CarilerPage, TYPE: "NAV", },
    { PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
 
  ];
  KullaniciMainMenu = [
    { PAGE_NAME: "Servis Kayitları", PAGE_ICON: "fa fa-file-text fa-3x", PAGE_COMPONENT: IsListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Müşteriler", PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: CarilerPage, TYPE: "NAV", },
    { PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
    // { PAGE_NAME: "Banka", PAGE_ION_ICON: "train", PAGE_ICON: "fa fa-university fa-3x", PAGE_COMPONENT: BankListePage,  TYPE: "NAV",  },
   // { PAGE_NAME: "Yönetim", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: YonetimAnaSayfaPage, TYPE: "NAV", },
    { PAGE_NAME: "ÇIKIŞ", PAGE_ICON: "fa fa-sign-out fa-3x", PAGE_COMPONENT: GirisPage, TYPE: "NAV", }
  ];
  YonetimMainMenu = [
    // { PAGE_NAME: "Banka", PAGE_ION_ICON: "train", PAGE_ICON: "fa fa-university fa-3x", PAGE_COMPONENT: BankListePage,  TYPE: "NAV",  },
    { PAGE_NAME: "Birimler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: BirimListePage, TYPE: "NAV", },
    { PAGE_NAME: "Kategoriler", PAGE_ICON: "fa fa-filter fa-3x", PAGE_COMPONENT: KategoriListePage, TYPE: "NAV", },
    { PAGE_NAME: "Markalar", PAGE_ICON: "fa fa-thumb-tack fa-3x", PAGE_COMPONENT: MarkaListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Kasalar", PAGE_ICON: "fa fa-briefcase fa-3x", PAGE_COMPONENT: KasalistePage, TYPE: "NAV", },
    { PAGE_NAME: "Kullanıcılar", PAGE_ICON: "fa fa-user fa-3x", PAGE_COMPONENT: KullaniciListePage, TYPE: "NAV", },
    { PAGE_NAME: "Durumlar", PAGE_ICON: "fa fa-file-text fa-3x", PAGE_COMPONENT: IsdurumPage, TYPE: "NAV", },
    { PAGE_NAME: "Personeller", PAGE_ICON: "fa fa-user fa-3x", PAGE_COMPONENT: PersonelListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Gelir-Gider", PAGE_ICON: "fa fa-arrows-h fa-3x", PAGE_COMPONENT: GelirgiderPage, TYPE: "NAV", },
    { PAGE_NAME: "Açıklamalar", PAGE_ICON: "fa fa-exclamation-triangle fa-3x", PAGE_COMPONENT: AciklamaListePage, TYPE: "NAV", },
    { PAGE_NAME: "Cari Grupları", PAGE_ICON: "fa fa-users fa-3x", PAGE_COMPONENT: GrupListesiPage, TYPE: "NAV", },
    { PAGE_NAME: "Yerel Ayarlar", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: ProgramAyarlariPage, TYPE: "NAV", },


  //  { PAGE_NAME: "Kdv Grupları", PAGE_ICON: "fa fa-percent fa-3x", PAGE_COMPONENT: AciklamaListePage, TYPE: "NAV", },
   // { PAGE_NAME: "Menşei", PAGE_ICON: "fa fa-globe fa-3x", PAGE_COMPONENT: AciklamaListePage, TYPE: "NAV", }
  ];
  RaporlarMainMenu = [
    { PAGE_NAME: "Gün Sonu Raporu", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    { PAGE_NAME: "Kasiyer Bazlı Rapor", PAGE_ICON: "fa fa-users fa-3x", PAGE_COMPONENT: KasiyerBazliRaporPage, TYPE: "NAV", },
    { PAGE_NAME: "Personel Servis Raporu", PAGE_ICON: "fa fa-line-chart fa-3x", PAGE_COMPONENT: PersonelServisRaporuPage, TYPE: "NAV", },
    // { PAGE_NAME: "Kategori Bazlı Rapor", PAGE_ICON: "fa fa-bar-chart fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Marka Bazlı Rapor", PAGE_ICON: "fa fa-tags fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Kdv Raporu", PAGE_ICON: "fa fa-percent fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    { PAGE_NAME: "Borçlu Cari Hesaplar", PAGE_ICON: "fa fa-briefcase fa-3x", PAGE_COMPONENT: BorcluCariHesaplarReportPage, TYPE: "NAV", },
    { PAGE_NAME: "Alacaklı Cari Hesaplar", PAGE_ICON: "fa fa-briefcase fa-3x", PAGE_COMPONENT: AlacakliCariHesaplarReportPage, TYPE: "NAV", },
    { PAGE_NAME: "Gelir/Gider Raporu", PAGE_ICON: "fa fa-arrows-h fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },

    { PAGE_NAME: "Kasa Hareketleri", PAGE_ICON: "fa fa-money fa-3x", PAGE_COMPONENT: KasaHareketleriRaporPage, TYPE: "NAV", },
  ];


}



// WEBPACK FOOTER //
// ./src/providers/pages-provider.ts